import { useState } from "react";
import { LinkOffOutlined, LinkOutlined } from "@mui/icons-material";
import useCarrierServiceList from "$hooks/useCarrierServiceList";
import { Text } from "$components";
import JTable from "$components/JTable/JTable";
import { CarrierService } from "$types";
import { ACTIVITIES_LABELS } from "$utils/typeConstants";
import useJStyles from "$hooks/useJStyles";
import { theme } from "$utils/theme/bataillog";
import ShippingConfigPopin from "./ShippingConfigPopin";

enum ERROR_MSG {
  NO_CARRIER = "Aucun service de livraison n'a été trouvé",
  NO_RESULTS = "Aucun résultat ne correspond à votre recherche",
  LOADING = "Chargement en cours",
}

const columns = [
  {
    id: "carrier-service",
    Header: "Service de livraison",
    Cell: ({ row }: any) => row.original.carrierServiceCell,
  },
  {
    id: "connector",
    Header: "Connecteur",
    Cell: ({ row }: any) => row.original.connectorCell,
  },
  {
    id: "attached-agency",
    Header: "Agence rattachée",
    Cell: ({ row }: any) => row.original.agencyCell,
  },
  {
    id: "attached-agency-service",
    Header: "Service d'agence rattaché",
    Cell: ({ row }: any) => row.original.agencyServiceCell,
  },
  {
    id: "is-attached",
    Header: "",
    Cell: ({ row }: any) => row.original.isAttachedCell,
  },
];

function ShippingConfigList() {
  const { jclasses } = useJStyles();
  const { carrierServices, fetchCarrierServices, isFetching } =
    useCarrierServiceList();
  const [selectedCarrierService, selectCarrierService] =
    useState<CarrierService | null>(null);
  const [isPopinOpen, togglePopin] = useState<boolean>(false);

  const onDrawerSubmit = () => {
    togglePopin(false);
    fetchCarrierServices();
  };

  const data =
    carrierServices?.map((carrierService) => ({
      carrierServiceCell: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={carrierService.carrierLogo}
            alt={carrierService.carrierName}
            style={{ height: 40, margin: "4px 16px 4px 0" }}
          />
          <Text>{`${carrierService.carrierName} ${carrierService.label} (${carrierService.serviceName})`}</Text>
        </div>
      ),
      connectorCell: <Text>{carrierService.connector || "N/A"}</Text>,
      agencyCell: <Text>{carrierService.company?.name || "N/A"}</Text>,
      agencyServiceCell: (
        <Text>
          {ACTIVITIES_LABELS[carrierService.carrierActivity] || "N/A"}
        </Text>
      ),
      isAttachedCell: carrierService.company?.name ? (
        <LinkOffOutlined style={{ color: theme.color.blueLight }} />
      ) : (
        <LinkOutlined style={{ color: theme.color.blueLight }} />
      ),
      _carrierService: carrierService,
    })) ?? [];

  return (
    <>
      {/* Relative for the no results placeholder */}
      <div style={{ position: "relative" }}>
        <JTable
          data={data}
          columns={columns}
          setPageIndex={() => {}}
          hideCheckboxes
          hideFilters
          usePaper={false}
          isFetching={isFetching}
          rowsPerPage={50}
          rowProps={(row) => ({
            onClick: () => {
              selectCarrierService(row.original._carrierService);
              togglePopin(true);
            },
            style: { cursor: "pointer" },
          })}
        />
        {!data.length && (
          <div className={jclasses.jNoResultPlaceHolder}>
            {!isFetching && !data.length && (
              <Text type="h3">
                {carrierServices?.length
                  ? ERROR_MSG.NO_RESULTS
                  : ERROR_MSG.NO_CARRIER}
              </Text>
            )}
          </div>
        )}

        <ShippingConfigPopin
          isOpen={isPopinOpen}
          onSubmit={onDrawerSubmit}
          onClose={() => togglePopin(false)}
          carrierServiceId={selectedCarrierService?.id}
        />
      </div>
    </>
  );
}

export default ShippingConfigList;
